import { Component, OnInit, Input } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  faGrid,
  faList,
  faArrowDownAZ,
  faArrowUpZA,
} from "@fortawesome/pro-light-svg-icons";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { environment } from "../../../../environments/environment";
import { debounceTime } from "rxjs/operators";
@Component({
    selector: "app-canvas-list",
    templateUrl: "./canvas-list.component.html",
    styleUrls: ["./canvas-list.component.scss"],
    standalone: false
})
export class CanvasListComponent implements OnInit {
  public canvasForm!: UntypedFormGroup;

  constructor(
    private canvasService: CanvasService,
    public commonService: CommonService,
    private fb: UntypedFormBuilder
  ) {}
  @Input() canvasType?: any;
  @Input() categories?: any;

  public canvas_listing: any[] = [];

  public p: number = 1;
  public breakpoint: number = 4;
  public display_data: string = "grid";
  public status: boolean = true;
  public filtered_reports: any;
  public sort_view_asc: boolean = true;
  public pagination: any;
  public error: string = "";
  public page = 1;
  public totalCanvasObjectResults: number = 0;

  public canvasListLoaded = false;

  faList = faList;
  faGrid = faGrid;

  faSearch = faSearch;
  faArrowDownAZ = faArrowDownAZ;
  faArrowUpZA = faArrowUpZA;
  public direction = false;

  getAllCanvasObjects() {
    this.canvasService
      .getAllCanvasObjects(1, 12, false, "", "")
      .subscribe((data: any) => {
        this.canvasListLoaded = true;
        this.canvas_listing = data.data;
        this.pagination = data.meta.pagination;
        //  assign a valid category to the report or random
        this.canvas_listing.forEach((report) => {
          let tempApp = this.getCategory(report.category_id);
          report.category = tempApp;
        });
        if (data.meta.pagination)
          this.totalCanvasObjectResults = data.meta.pagination.total;
      });
  }
  getCanvas(page: number, direction: boolean) {
    const searchTerm = this.canvasForm.get("searchTerm")!.value;
    const category = this.canvasForm.get("category")!.value;
    this.canvasService
      .searchListing(page, 12, direction, category, searchTerm)
      .subscribe((data: any) => {
        this.canvas_listing = data.data;
        this.pagination = data.meta.pagination;
        //  assign a valid category to the report or random
        this.canvas_listing.forEach((report) => {
          let tempApp = this.getCategory(report.category_id);
          report.category = tempApp;
        });
        this.totalCanvasObjectResults = data.meta.pagination.total;
      });
  }

  searchCanvasItems() {
    this.direction = false;
    this.page = 1; // keep in sync with the page-1 fetch below, else a later sort reuses a stale page
    const searchTerm = this.canvasForm.get("searchTerm")!.value;
    const category = this.canvasForm.get("category")!.value;
    this.canvasListLoaded = false;
    if (!searchTerm) {
      this.canvasService
        .searchListing(1, 12, false, category, searchTerm)
        .subscribe((data: any) => {
          this.canvasListLoaded = true;
          this.canvas_listing = data.data;
          this.pagination = data.meta.pagination;
          //  assign a valid category to the report or random
          this.canvas_listing.forEach((report) => {
            let tempApp = this.getCategory(report.category_id);
            report.category = tempApp;
          });
          if (data.meta && data.meta.pagination && data.meta.pagination.total) {
            this.totalCanvasObjectResults = data.meta.pagination.total;
          }
        });
    }
    if (searchTerm && searchTerm.length > 0) {
      if (searchTerm.length < 2) {
        // this.canvasForm.get("searchTerm")!.setValue("");
        this.error = "you have to provide at least 2 characters to search";
        setTimeout(() => (this.error = ""), 3000);
        return;
      }
      this.canvasService
        .searchListing(1, 12, this.direction, category, searchTerm)
        .subscribe((data: any) => {
          this.canvasListLoaded = true;
          this.canvas_listing = data.data;
          this.pagination = data.meta.pagination;
          //  assign a valid category to the report or random
          this.canvas_listing.forEach((report) => {
            let tempApp = this.getCategory(report.category_id);
            report.category = tempApp;
          });
          if (data.meta && data.meta.pagination && data.meta.pagination.total) {
            this.totalCanvasObjectResults = data.meta.pagination.total;
          }
        });
    }
  }
  getCategory(id: number) {
    let selected =
      this.categories &&
      this.categories.filter(function (module: any) {
        return module.id == id;
      });
    if (selected && selected[0]) return selected[0].name;
    else return "";
  }

  displayList(display: string, event: any) {
    //switches from grid to list view
    this.display_data = display;
    let viewIcon = document.querySelectorAll(".reports_view");
    for (let i = 0; i < viewIcon.length; i++) {
      viewIcon[i].classList.remove("active");
    }
    if (display == "list") {
      viewIcon[1].classList.add("active");
    } else {
      viewIcon[2].classList.add("active");
    }
  }

  changeSort(event: any) {
    if (this.direction) {
      this.direction = false;
    } else {
      this.direction = true;
    }
    this.getCanvas(this.page, this.direction);
  }

  handlePageChange(event: any) {
    this.page = event;
    this.getCanvas(this.page, this.direction);
  }

  ngOnInit(): void {
    this.filtered_reports = this.canvas_listing;

    this.canvasForm = this.fb.group({
      category: new UntypedFormControl(""),
      searchTerm: new UntypedFormControl(),
    });

    this.getAllCanvasObjects();

    // setting a debounce after keyup
    this.canvasForm.controls["searchTerm"].valueChanges
      .pipe(debounceTime(1000))
      .subscribe(() => this.searchCanvasItems());
  }
}
